import { z } from 'zod';
import { FeedKindSchema } from './kind.js';
import { FeedListJobKindSchema } from './listJob.js';
import { FeedListJobConfigSchema } from './listJobConfig.js';
import { FeedProcessingConfigSchema } from './processingConfig.js';
export const FeedCreateSchema = z
    .object({
    organizationId: z.uuid().optional(),
    kind: FeedKindSchema,
    name: z.string().min(1),
    enabled: z.boolean(),
    itemTrackingEnabled: z.boolean().optional(),
    ingestEnabled: z.boolean().optional(),
    practiceIds: z.array(z.uuid()).min(1),
    listJobKind: FeedListJobKindSchema.nullish(),
    listJobConfig: FeedListJobConfigSchema.optional(),
    processingConfig: FeedProcessingConfigSchema.nullish(),
    ehrInstanceId: z.uuid().nullish(),
    appendWhenAutomated: z.boolean().optional(),
    removeWhenAutomated: z.boolean().optional(),
    campaignId: z.uuid().nullish(),
    reportReferenceValue: z.string().min(1).nullish(),
})
    .strict();
/**
 * Every field is optional, but sending none of them is rejected rather than treated as a no-op.
 * `deletedTimestamp` only ever takes null: a feed is deleted through `DELETE`, and undeleted here.
 */
export const FeedUpdateSchema = FeedCreateSchema.partial()
    .extend({
    organizationId: z.uuid().nullish(),
    deletedTimestamp: z.null().optional(),
})
    .strict()
    .refine((values) => Object.keys(values).length > 0, {
    message: 'At least one field must be provided',
});
//# sourceMappingURL=upsert.js.map